import React from 'react'

import { DropdownButton } from './DropdownButton'
import { MatchStoreProductsButtons } from './MatchStoreProductsButtons'

export const MatchProductsDropdownButton =
  () =>
    <DropdownButton text="Матчинг" loadingText="Загрузка..." popupWidth={300}>
      {buttonProps => <MatchStoreProductsButtons buttonProps={buttonProps}/>}
    </DropdownButton>